import React from 'react';
import { Col, Row } from 'antd';
import { DetalhesViagem } from '../DetalhesViagem';

export function TabViagem({ detalhesViagem }) {
  return <Row
    justify="space-between"
    style={{
      padding: '16px 0',
    }}
  >
    <Col justify="center" md={24} lg={24} xs={24}>
      <DetalhesViagem detalhesViagem={detalhesViagem} />
    </Col>
         </Row>;
}
